import Footer from "../components/common/Footer";
import Navbar from "../components/common/NavBar";
import "chart.js/auto";
import styles from "../styles/common/index.module.css";
import Grid from "@mui/material/Grid";
import TotalBudgetPerFund from "../components/charts/TotalBudgetPerFund";
import Banner from "../components/home/Banner";
import StatsBar from "../components/home/StatsBar";
import ChallengeFundsInFund from "../components/charts/ChallengeFundsInFund";
import { Container } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../components/error/ErrorHandler";
import ProposalCountAmountSum from "../components/charts/ProposalCountAmountSumChart";
import FundAvailability from "../components/charts/FundAvailability";
// import TwitterWordCloud from "../components/charts/twitter/TwitterWordCloud";
// import TwitterProperty from "../components/charts/twitter/TwitterProperty";

export default function HomeIndex() {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
        <Navbar />
        <Banner />
        <StatsBar />
        <Container>
          <Grid
            container
            justifyContent="center"
            spacing={4}
            sx={{ marginTop: "5px", paddingBottom: "100px" }}
          >
            <Grid item xs={12} lg={6} sm={12} className={styles.chartItem}>
              <TotalBudgetPerFund
                chartTitle="Total Budget in Each Fund"
                xLabel="Fund"
                yLabel="Total ($)"
              />
            </Grid>
            <Grid
              item
              container
              xs={12}
              lg={6}
              sm={12}
              className={styles.chartItem}
            >
              <ChallengeFundsInFund showSelect="flex" />
            </Grid>
            <Grid
              item
              container
              xs={12}
              lg={6}
              sm={12}
              className={styles.chartItem}
            >
              <FundAvailability />
            </Grid>
            <Grid
              item
              container
              xs={12}
              lg={6}
              sm={12}
              className={styles.chartItem}
            >
              <ProposalCountAmountSum
                xlabel="Fund"
                ylabel="Proposal Count"
                InitialStatus="All"
                shouldShowDropDown={false}
              />
            </Grid>
          </Grid>
        </Container>

        <div id="notebook"></div>
        {/* <>{embedNotebook()}</> */}
        <Footer />
      </ErrorBoundary>
    </>
  );
}
